
export interface MenuItem {
  label: string;
  href: string;
  icon?: string;
  submenu?: MenuItem[];
}

export const MENU_ITEMS: MenuItem[] = [
  { label: "Home", href: "https://www.CarSparesEzyFind.co.za/" },
  { label: "Car Parts For Sale", href: "https://www.CarSparesEzyFind.co.za/car-parts-spares-near-me" },
  { label: "Spare Shops / Scrap Yards", href: "https://www.CarSparesEzyFind.co.za/spare-shops-near-me" },
  { label: "Articles", href: "https://www.CarSparesEzyFind.co.za/article" },
  { label: "Specials", href: "https://www.CarSparesEzyFind.co.za/special" },
  { 
    label: "Tools & Calculators", 
    href: "https://www.CarSparesEzyFind.co.za/online-automotive-calculators-and-tools/online-automotive-calculators-and-tools-list",
    icon: "🔧",
    submenu: [
      {
        label: "Vehicle Diagnosis Quiz",
        href: "https://www.CarSparesEzyFind.co.za/online-automotive-calculators-and-tools/vehicle-diagnosis-quiz"
      },
      {
        label: "Tyre Size Calculator",
        href: "https://www.CarSparesEzyFind.co.za/online-automotive-calculators-and-tools/tyre-size-calculator"
      },
      {
        label: "Wheel Size Visualizer",
        href: "https://www.CarSparesEzyFind.co.za/online-automotive-calculators-and-tools/wheel-size-visualizer"
      },
      {
        label: "Turbo Size Calculator",
        href: "https://www.CarSparesEzyFind.co.za/online-automotive-calculators-and-tools/turbo-size-calculator"
      }
    ]
  },
  { label: "Business Pricing", href: "https://www.CarSparesEzyFind.co.za/list-business" }, 
  { label: "Contact", href: "https://www.CarSparesEzyFind.co.za/contact" },
  { label: "About", href: "https://www.CarSparesEzyFind.co.za/about" },
];